import { RouteType } from "../config";
import DepartureBoardIcon from "@material-ui/icons/DepartureBoard";
import SolicitacaoCTePage from "../../pages/SolicitacaoCTe/SolicitacaoCTePage";
import HomePage from "../../pages/home/HomePage";
import SolicitacaoMDFePage from "../../pages/SolicitacaoMDFe/SolicitacaoEncerramentoMDFePage";
import DashboardPageLayout from "../../components/layout/DashboardPageLayout";

const grupoCte: RouteType = {
  path: "/cte_mdfe",
  show: true,
  element: <DashboardPageLayout />,
  state: "SOLICITACAO_CTE",
  verificarPermissao: (usuario) => {
    return usuario?.perfil.podeAcessarSolicitacaoCte ?? false;
  },
  sidebarProps: {
    displayText: "CT-e / MDF-e",
    icon: <DepartureBoardIcon />,
  },
   child: [
    {
      index: true,
      element: <HomePage />,
      state: "configuracao.index",
      show: true,
    },
    {
      path: "/cte_mdfe/cte",
      element: <SolicitacaoCTePage />,
      state: "SOLICITACAO_CTE.CTE",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeAcessarSolicitacaoCte ?? false;
      },
      sidebarProps: {
        displayText: "Solicitação de CT-e",
      },
    },

    {
      path: "/cte_mdfe/mdfe",
      element: <SolicitacaoMDFePage />,
      state: "SOLICITACAO_CTE.MDFE",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeAcessarSolicitacaoCte ?? false;
      },
      sidebarProps: {
       displayText: "Solicitação encerramento MDF-e",
      },
    },
  ],
}




export default grupoCte;
